import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.484.003a11.696 11.696 0 0 0-8.155 3.5A11.307 11.307 0 0 0 .001 11.7 11.287 11.287 0 0 0 11.31 23h.205a11.605 11.605 0 0 0 11.485-11.699A11.276 11.276 0 0 0 11.484.003Zm-1.421 15.85a1.415 1.415 0 0 1 1.388-1.466h.026a1.463 1.463 0 0 1 1.46 1.409 1.415 1.415 0 0 1-1.389 1.466h-.026a1.465 1.465 0 0 1-1.46-1.409Zm.479-3.873V6.231a.958.958 0 1 1 1.916 0v5.75a.958.958 0 1 1-1.916 0Z",
		fill: "currentColor"
	})
});
export { SvgAlertCircle as ReactComponent };
